export function getMediaCurrentTime(mediaElement?: HTMLMediaElement | null): number | null {
  if (!mediaElement) {
    return null;
  }
  if (mediaElement.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
    return null;
  }
  if (isNaN(mediaElement.duration) || isNaN(mediaElement.currentTime)) {
    return null;
  }
  return mediaElement.currentTime;
}